import axiosInstance from "shared/axios";
import { MOBILE_NUMBER_CHANGE_REQUEST } from "shared/constants";
import { queryparamBuilder } from "shared/utils";

export const fetchMobileNumberRequestList = (selected, search, param) => {
  let uri = MOBILE_NUMBER_CHANGE_REQUEST.listing;
  if (selected && search) {
    uri += `?${selected}=${encodeURIComponent(search)}&`;
  } else if (Object.keys(param).length) {
    uri += "?";
  }
  uri += queryparamBuilder(param);
  return axiosInstance.get(`${uri}`);
};

export const sendLink = (payload) => {
  let url = `${MOBILE_NUMBER_CHANGE_REQUEST.sendLink}`;
  return axiosInstance.post(url, payload);
};
export const addObjection = (payload) => {
  let url = `${MOBILE_NUMBER_CHANGE_REQUEST.objection}`;
  return axiosInstance.post(url, payload);
};
export const resolveObjection = (payload) => {
  let url = `${MOBILE_NUMBER_CHANGE_REQUEST.resolveObjection}`;
  return axiosInstance.post(url, payload);
};
export const requestReject = (payload) => {
  let url = `${MOBILE_NUMBER_CHANGE_REQUEST.reject}`;
  return axiosInstance.post(url, payload);
};

